<template>
    <Dialog v-model="state" :scrollable="false" :hasCloseButton="false" no-padding no-radius>
        <div class="default-sending-popup" v-loading="loading || templateLoading">
            <div class="default-sending-popup__header">
                <h2 class="default-sending-popup__title">Создание рассылки</h2>
                <CloseTemplateIcon class="default-sending-popup__close-icon" @click="$emit('close')" />
            </div>
            <div class="default-sending-popup__body">
                <div class="default-sending-popup__column">
                    <div class="default-sending-popup__input-wrapper">
                        <div v-if="prettieredQuantity" class="default-sending-popup__recipients-count">
                            Количество получателей: {{ prettieredQuantity }}
                        </div>
                        <ModelString
                            class="default-sending-popup__input"
                            label="Тема"
                            :invalidateFunction="() => errors.subject"
                            v-model="formData.subject"
                            :error="!!errors.subject"
                            :error-message="errors.subject"
                        />
                        <ModelTinyMce
                            label="Текст рассылки"
                            class="default-sending-popup__input"
                            :error-message="errors.htmlText"
                            :error="!!errors.htmlText"
                            v-model="formData.htmlText"
                        />
                        <ModelString
                            class="default-sending-popup__input"
                            label="https://"
                            :invalidateFunction="() => errors.link_0_url"
                            v-model="formData.link_0_url"
                            @change="updateLinkUrl"
                            :error="!!errors.link_0_url"
                            :error-message="errors.link_0_url"
                        />
                        <ModelString
                            class="default-sending-popup__input"
                            label="Текст кнопки"
                            :invalidateFunction="() => errors.link_0_text"
                            @change="() => errors.link_0_text = ''"
                            v-model="formData.link_0_text"
                            :error="!!errors.link_0_text"
                            :error-message="errors.link_0_text"
                        />
                    </div>

                    <button
                        class="default-sending-popup__footer-button"
                        :class="{
                                'default-sending-popup__footer-button--disable': !allowSubmit,
                            }"
                        @click="submit"
                    >
                        Отправить
                    </button>
                </div>
                <div class="default-sending-popup__column default-sending-popup__column--preview">
                    <div class="default-sending-popup__preview" v-html="preview"></div>
                </div>
            </div>
        </div>
    </Dialog>
</template>

<script>
import {isEmpty} from "@/tools/filters";
import debounce from '@/tools/debounce';
import Dialog from '@/components/UI/Dialog';
import ModelString from '@/components/UI/models/ModelString';
import ModelTinyMce from '@/components/UI/models/ModelTinyMce';
import CloseTemplateIcon from '@/assets/images/icons/close-template-icon.svg?inline';
import {get} from "@/tools/http";
import buttonTemplate from "!raw-loader!@/components/user-search/notification/data/buttonTemplate.html";

export default {
    name: "UserSearchNotificationDialogEmailDefault",

    components: {
        Dialog,
        ModelString,
        CloseTemplateIcon,
        ModelTinyMce,
    },

    emits: [ "close", "submit", "update-data" ],

    props: {
        loading: Boolean,
        prettieredQuantity: String,
        countedQuantityText: String,
    },

    data: () => ({
        buttonTemplate: buttonTemplate,
        state: true,
        templateLoading: true,
        templatePreview: '',

        formData: {
            subject: '',
            htmlText: '',
            link_0_text: '',
            link_0_url: '',
        },

        errors: {
            subject: '',
            htmlText: '',
            link_0_text: '',
            link_0_url: '',
        },
    }),

    beforeMount() {
        this.state = true;

        for (const k in this.formData) {
            this.$set(this.formData, k, '');
            this.$set(this.errors, k, '');
        }

        this.$nextTick(async () => await this.initTemplate());
    },

    watch: {
        state(val) {
            if (!val && val !== this.show) {
                this.$emit("close");
            }
        },
        formData: {
            handler(newVal, oldVal) {
                for (const k in newVal) {
                    if (newVal[k] !== oldVal[k]) {
                        this.$set(this.errors, k, '');
                    }
                }

                debounce(() => {
                    this.$emit("update-data", newVal);
                }, 10, false, 'user-search-notification-email-default')();

            },
            deep: true,
        },
    },

    computed: {
        hasErrors() {
            return Object.keys(this.errors).filter(k => !isEmpty(this.errors[k])).length > 0;
        },
        allowSubmit() {
            return this.formData.subject
                && this.formData.htmlText
                && !this.hasErrors
            ;
        },

        buttonHtml() {
            const formData = this.formData;

            return formData.link_0_url
                ? buttonTemplate
                    .replaceAll(/\{\{ link_0_url }}/g, formData.link_0_url)
                    .replaceAll(/\{\{ link_0_text }}/g, formData.link_0_text)
                : ""
            ;
        },

        preview() {
            const formData = this.formData;

            return this.templatePreview
                .replace(/{{ theme }}/g, formData.subject || '{{ Title }}')
                .replace(/{{ text }}/g, (formData.htmlText || '{{ Text }}') + this.buttonHtml)
                .replace(/{{ footer }}/g, '')
            ;
        },
    },

    methods: {
        updateLinkUrl() {
            if (!/^http(s)?:\/\//.test(this.formData.link_0_url)) {
                this.formData.link_0_url = `https://${this.formData.link_0_url}`;
                this.errors.link_0_url = '';
            }
        },

        validateUrl(url) {
            try {
                return /^http(s?):\/\/[a-z0-9_\-.:]+\/?/.test(url.toLowerCase())
                    && !!(new URL(url))
                ;
            } catch (_) {
                return false;
            }
        },

        async getEmailTemplate(name) {
            return await get('notify', 'email/templates', { templateName: name }, {}, {});
        },

        validate() {
            this.errors.subject = this.formData.subject.trim() === '' ? 'Введите тему' : '';

            const htmlText = this.formData.htmlText.trim();

            if (htmlText) {
                const container = document.createElement('div');
                container.innerHTML = htmlText;

                const links = container.getElementsByTagName('a');
                const images = container.getElementsByTagName('img');

                const errors = [];

                for (const a of links) {
                    const url = a.getAttribute('href');

                    if (!this.validateUrl(url)) {
                        errors.push(`Невалидная ссылка: ${a.text} => ${url}`);
                    }
                }

                for (const img of images) {
                    const url = img.getAttribute('src');

                    if (!this.validateUrl(url)) {
                        errors.push(`Невалидная ссылка изображения: ${url}`);
                    }
                }

                this.errors.htmlText = errors.length ? errors.join('<br/>') : '';
            } else {
                this.errors.htmlText = 'Введите текст рассылки';
            }

            if (this.formData.link_0_text.trim() !== '' && this.formData.link_0_url.trim() === '') {
                this.errors.link_0_url = 'Введите ссылку';
            } else if (this.formData.link_0_url.trim() !== '') {
                try {
                    new URL(this.formData.link_0_url);
                } catch (_) {
                    this.errors.link_0_url = 'Невалидная ссылка';
                }
            } else {
                this.errors.link_0_url = '';
            }

            if (this.formData.link_0_url.trim() !== "" && this.formData.link_0_text.trim() === "") {
                this.errors.link_0_text = "Введите текст кнопки";
            }

            return !this.hasErrors;
        },

        submit() {
            if (this.validate()) {
                this.$emit("submit", {...this.formData, htmlText: this.formData.htmlText + this.buttonHtml});
            }
        },

        async initTemplate() {
            this.templateLoading = true;

            const templateResult = await this.getEmailTemplate('default');

            this.templatePreview = templateResult
                ? templateResult.data
                : 'Ошибка загрузки шаблона'
            ;

            this.templateLoading = false;
        },
    },
};
</script>

<style scoped lang="scss">
@import '~@/styles/rem';
@import '~@/styles/variables';

.default-sending-popup {
    background: #fff;
    margin-top: urem(-80);

    @include on-desktop {
        width: urem(1220);
        margin-top: 0;
    }

    :deep(.mt-invalid) {
        .mt-invalid-text {
            @include set-font-size(16);
        }
    }

    &__header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: urem(20);
        background: $color-main-blue;
        @include on-desktop {
            width: urem(1220);
        }
    }

    &__recipients-count {
        @include set-font-size(16, 400, 20);
        margin-bottom: urem(24);
    }
    &__title {
        color: #fff;
        margin: 0;
        @include set-font-size(18, 700, 24);
        @include on-desktop {
            @include set-font-size(24, 600, 32);
        }
    }
    &__close-icon {
        width: urem(12);
        height: urem(12);
        @include on-desktop {
            cursor: pointer;
        }
    }
    &__body {
        height: 90vh;
        overflow-x: scroll;
        padding: urem(12);
        @include on-desktop {
            display: flex;
            overflow: auto;
            height: 75vh;
            padding: 0;
        }
    }

    &__column {
        @include on-desktop {
            width: 50%;
            padding: urem(40);
        }
        &--preview {
            background: #edeef0;
        }
    }

    &__input-wrapper {
        margin-bottom: urem(40);
    }

    &__input {
        margin-bottom: urem(24);
        &:last-child {
            margin-bottom: 0;
        }
    }

    &__footer-button {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        padding: urem(14) urem(32);
        margin: urem(24) 0;
        background: $color-main-blue;
        border: none;
        border-radius: urem(10);
        text-align: center;
        color: #ffffff;
        @include set-font-size(14, 600, 20);
        @include on-desktop {
            width: auto;
            cursor: pointer;
        }

        &--disable {
            opacity: 0.5;
            pointer-events: none;
        }
    }

    &__preview {
        :deep(table),
        :deep(td) {
            border: 0;
        }
    }
}
</style>
